import strings from "@subly/s1/core/strings";


export default {
	...strings
};